export const videoMetaData = {
    isRepeatable: false
}
